import { isFybrAdminUser } from "./adminRoles";
import { useAdminGate, type AdminGate } from "./useAdminGate";

export type InternalCloudAdminGate = AdminGate;

/**
 * Cloud Admin (`/internal/*`) may render only for fybr_admin after auth resolves.
 * Use in layout and internal route components so disallowed users see nothing.
 */
export const useInternalCloudAdminGate = (): InternalCloudAdminGate =>
  useAdminGate(isFybrAdminUser);
